module.exports = __webpack_public_path__ + "static/media/ProximaNova-SemiboldItalic.1e378969.otf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola/zola-ui/build/assets/fonts/ProximaNova-SemiboldItalic.otf
// module id = 1181
// module chunks = 49